import { defineStore } from "pinia";

export const sessionStore = defineStore({
  id: "session",
  state: () => ({
    access_token: null,
    expires_in: null,
    token_type: null,
    scope: null,
    refresh_token: null,
  }),
  getters: {
    asB64(state) {
      return btoa(JSON.stringify(state));
    },
  },
  actions: {
    sync(data) {
      this.access_token = data.access_token;
      this.expires_in = data.expires_in;
      this.token_type = data.token_type;
      this.scope = data.scope;
      this.refresh_token = data.refresh_token;

      for (const key in data) {
        window.localStorage.setItem(key, data[key]);
      }
      if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent('kosexa-oauth-session-sync'));
      }
    },
    /** Restaura Pinia desde localStorage (tras F5 o nueva pestaña). */
    hydrateFromLocalStorage() {
      if (typeof window === 'undefined' || !window.localStorage) return;
      const access = window.localStorage.getItem('access_token');
      if (!access) {
        this.access_token = null;
        this.refresh_token = null;
        this.expires_in = null;
        this.token_type = null;
        this.scope = null;
        return;
      }
      this.access_token = access;
      this.refresh_token = window.localStorage.getItem('refresh_token');
      this.expires_in = window.localStorage.getItem('expires_in');
      this.token_type = window.localStorage.getItem('token_type');
      this.scope = window.localStorage.getItem('scope');
      if (typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent('kosexa-oauth-session-sync'));
      }
    },
    /** Cierra sesión OAuth en este dispositivo (localStorage + estado Pinia). */
    clearSession() {
      this.access_token = null;
      this.expires_in = null;
      this.token_type = null;
      this.scope = null;
      this.refresh_token = null;
      if (typeof window === 'undefined' || !window.localStorage) return;
      const keys = ['access_token', 'refresh_token', 'expires_in', 'token_type', 'scope'];
      keys.forEach((k) => {
        try {
          window.localStorage.removeItem(k);
        } catch {
          /* ignore */
        }
      });
      if (typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent('kosexa-oauth-session-sync'));
      }
    },
  },
});
